import React, { useState } from 'react';

const EmailModal = ({ open, filename, onClose, onSend, busy = false, busyText = 'Sending…' }) => {
  const [to, setTo] = useState('');
  const [cc, setCc] = useState('');
  const [bcc, setBcc] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [pagesMode, setPagesMode] = useState('all'); // 'all' | 'range'
  const [pageRange, setPageRange] = useState(''); // e.g. 1-3,5

  if (!open) return null;

  return (
    <div style={overlay}>
      <div style={{ ...modal, position: 'relative' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>Email PDF</h3>
          <button className="btn btn-clear" onClick={onClose} disabled={busy}>Close</button>
        </div>
        <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text)' }}>
          File: <strong>{filename}</strong>
        </div>
        <div style={{ marginTop: 12 }}>
          <div style={row}><label style={label}>To</label><input style={input} value={to} onChange={e => setTo(e.target.value)} placeholder="comma-separated" disabled={busy} /></div>
          <div style={row}><label style={label}>CC</label><input style={input} value={cc} onChange={e => setCc(e.target.value)} placeholder="optional" disabled={busy} /></div>
          <div style={row}><label style={label}>BCC</label><input style={input} value={bcc} onChange={e => setBcc(e.target.value)} placeholder="optional" disabled={busy} /></div>
          <div style={row}><label style={label}>Subject</label><input style={input} value={subject} onChange={e => setSubject(e.target.value)} disabled={busy} /></div>
          <div style={row}><label style={label}>Message</label><textarea style={{ ...input, minHeight: 80 }} value={message} onChange={e => setMessage(e.target.value)} disabled={busy} /></div>
          <div style={{ ...row, gap: 10 }}>
            <label style={label}>Pages</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <label><input type="radio" checked={pagesMode==='all'} onChange={() => setPagesMode('all')} disabled={busy} /> Entire PDF</label>
              <label><input type="radio" checked={pagesMode==='range'} onChange={() => setPagesMode('range')} disabled={busy} /> Page range</label>
              <input
                style={{ ...input, width: 180, opacity: pagesMode==='range' ? 1 : 0.6 }}
                placeholder="e.g. 1-3,5"
                disabled={pagesMode !== 'range' || busy}
                value={pageRange}
                onChange={e => setPageRange(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button className="btn btn-primary" onClick={() => onSend && onSend({ to, cc, bcc, subject, message, pagesMode, pageRange })} disabled={busy}>Send</button>
          <button className="btn btn-clear" onClick={onClose} disabled={busy}>Cancel</button>
        </div>

        {busy && (
          <div style={busyLayer}>
            <div style={busyBox}>
              <div style={spinner}></div>
              <div style={{ marginTop: 10 }}>{busyText}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1001, display: 'flex', alignItems: 'center', justifyContent: 'center' };
const modal = { width: 520, maxWidth: '95vw', background: 'var(--modal-bg)', color: 'var(--text)', borderRadius: 8, padding: 16, boxShadow: '0 10px 30px rgba(0,0,0,0.4)' };
const busyLayer = { position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 };
const busyBox = { background: 'var(--modal-bg)', color: 'var(--text)', padding: 16, borderRadius: 8, boxShadow: '0 6px 18px rgba(0,0,0,0.3)', display: 'flex', flexDirection: 'column', alignItems: 'center' };
const spinner = { border: '6px solid #e0e0e0', borderTop: '6px solid #1565c0', borderRadius: '50%', width: 36, height: 36, animation: 'spin 1s linear infinite' };
const row = { display: 'flex', flexDirection: 'column', marginBottom: 10 };
const label = { fontSize: 12, marginBottom: 4 };
const input = { padding: '8px 10px', borderRadius: 6, border: '1px solid var(--border-soft)', background: 'var(--input-bg)', color: 'var(--text)' };

export default EmailModal;
